import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Visit from "./components/Visit";
import Watch from "./components/Watch";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Visit />
        <Watch />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
